export default __webpack_public_path__ + "static/media/new-invoice.2cf4b0ca.svg";